import { useNavigate, useSearchParams } from 'react-router-dom';
import { MonitoringOverview } from '../../components/MonitoringOverview';
import { ProjectSection } from '../../components/project/ui';
import { useProject } from './ProjectContext';
import { ErrorGroupsPanel } from './wordpress/ErrorGroupsPanel';

/**
 * MonitoringSection is the whole monitoring surface: every check with its
 * state, the open incidents, alert thresholds and the automatic-fix policy.
 * The Overview only ever shows the monitoring problems that need somebody.
 */
export function MonitoringSection() {
  const project = useProject();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Why a check has not reported: the server's agent fact, when the agent
  // is the reason (UX-18).
  const agent = project.environmentHealth.data?.agent;
  const notReportedReason =
    agent && agent.level === 'critical' ? `the agent on ${agent.server_name ?? 'the server'} is not in contact` : null;

  return (
    <ProjectSection>
      {project.isWordPress ? <ErrorGroupsPanel /> : null}
      <MonitoringOverview
        projectId={project.projectId}
        focusMonitorId={searchParams.get('monitor')}
        notReportedReason={notReportedReason}
        setupMonitorsTo={project.sectionPath('infrastructure')}
        onNavigateToDeployment={(deploymentId) =>
          navigate(project.sectionPath('deployments', { deployment: deploymentId }))
        }
        onOpenIncidentAction={(target) => {
          // The action may name another environment of the project than the
          // one selected: switch to it, never act on the wrong store.
          const env = target.environmentId ? project.environments.find((e) => e.id === target.environmentId) : undefined;
          if (target.environmentId && !env) return;
          navigate(project.sectionPath(target.section, env ? { ...target.params, env: env.slug } : target.params));
        }}
      />
    </ProjectSection>
  );
}
